module.exports = __webpack_public_path__ + "images/2781f04a57416f6c080a121e5f0900a8.gif";